import { useEffect, useState } from "react";
import { Button, Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { deleteAttributeValue, getAttributeValues } from "../../../../../controllers/company/products/AttributesValuesController";
import AttributesValuesDataTable from "./dataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import QUDProgress from "../../../../../components/progress";

export default function AttributesValues()
{
    const theme = useTheme();
    const [attribute,setAttribute] = useState({});
    const [attributeValues,setAttributeValues] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const history = useHistory();
    const { attributeId } = useParams();

    useEffect(()=>{
        window.scrollTo(0,0);
        handleGetAttributesValues();
    },[])

    const redirect = (route) => {
        history.push(route)
    }

    const handleGetAttributesValues = async () => {
        setIsLoading(true);
        const response = await getAttributeValues(attributeId);
        if(response.success === true)
        {
            setAttribute(response.data.attribute);
            setAttributeValues(response.data.values);
        }
        setIsLoading(false);
    }

    const handleDeleteAttribute = async (id) => {
        setIsLoading(true);
        const response = await deleteAttributeValue(id);
        if(response.success === true)
        {
            //await handleGetAttributes();
            handleGetAttributesValues();
            //setAttributes(prevAttributes => prevAttributes.filter(attribute => attribute.id !== id));
        }
        setIsLoading(false);
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo='/products/attributes' 
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Atributos',link:'/products/attributes'},
                    {name:'Valores',link:'/products/attributes/values/'+attributeId}
                ]}
            />
            <br/>
            <SectionTitle title={attribute.name} subtitle={'(Atributo)'} />
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} style={{padding:15,backgroundColor:'#ebf9ff'}}>
                        <Grid container alignContent={'center'} justifyContent={'center'}>
                            <Grid item xs={12} lg={2} textAlign={'center'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                <FontAwesomeIcon icon={faInfoCircle} size='2x' color={theme.palette.link.main}/>
                            </Grid>
                            <Grid item xs={12} lg={10}>
                                <Typography variant="body1" color={theme.palette.text.secondary} gutterBottom>
                                    Añade las opciones individuales para el atributo <span style={{fontWeight:'bold'}}>'{attribute.name}'</span>.
                                    Cada una de estas opciones tendrá su propio valor y descripción.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={12} mt={5}>
                    <Button
                        mt={5}
                        variant='contained'
                        endIcon={<AddCircleIcon/>}
                        onClick={()=>redirect(`/products/attributes/values/${attributeId}/${attribute.name}/create`)}
                    >
                        <Typography>Agregar</Typography>
                    </Button>
                </Grid>
            </Grid>
            

            <Grid container spacing={3} mt={1}>
                <Grid item xs={12}>
                    <AttributesValuesDataTable
                        attributesValues={attributeValues}
                        onDelete={handleDeleteAttribute}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
        </Container>
    )
}